"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scoreboard = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var Scores = function (_a) {
    var scores = _a.scores;
    return (react_1.default.createElement("div", { className: 'storybook-producer-scoreboard-score' },
        react_1.default.createElement("span", null,
            scores[0],
            " \u2013 ",
            scores[1])));
};
var Team = function (_a) {
    var canSelect = _a.canSelect, colour = _a.colour, isSelected = _a.isSelected, nameAbbreviated = _a.nameAbbreviated, selectedTeam = _a.selectedTeam;
    return (react_1.default.createElement(storybook_1.Buttons.Button, { className: storybook_1.Helpers.arrayToString(__spreadArray(__spreadArray([
            'storybook-producer-scoreboard-team'
        ], (isSelected ? ['storybook-producer-scoreboard-team-selected'] : [])), (!canSelect ? ['storybook-producer-scoreboard-team-disabled'] : []))), onClick: function () { return canSelect ? selectedTeam() : function () { }; } },
        react_1.default.createElement("span", { className: 'storybook-producer-scoreboard-team-circle', style: { backgroundColor: colour } }),
        react_1.default.createElement("span", { className: 'storybook-producer-scoreboard-team-name' }, nameAbbreviated),
        react_1.default.createElement("span", { className: 'clear-both' })));
};
var Scoreboard = function (_a) {
    var canSelect = _a.canSelect, onSelectTeam = _a.onSelectTeam, selectedTeam = _a.selectedTeam, teams = _a.teams;
    if (teams.length !== 2) {
        return (react_1.default.createElement("div", { className: 'storybook-producer-scoreboard' },
            react_1.default.createElement("p", null, "Please configure two teams")));
    }
    return (react_1.default.createElement("div", { className: 'storybook-producer-scoreboard' },
        react_1.default.createElement("div", { className: 'storybook-producer-scoreboard-wrapper' },
            react_1.default.createElement(Team, __assign({ canSelect: canSelect, isSelected: selectedTeam.id === teams[0].id, selectedTeam: function () { return onSelectTeam(teams[0]); } }, teams[0])),
            react_1.default.createElement(Scores, { scores: teams.map(function (team) { return team.score; }) }),
            react_1.default.createElement(Team, __assign({ canSelect: canSelect, isSelected: selectedTeam.id === teams[1].id, selectedTeam: function () { return onSelectTeam(teams[1]); } }, teams[1])))));
};
exports.Scoreboard = Scoreboard;
exports.Scoreboard.propTypes = {
    canSelect: prop_types_1.default.bool,
    onSelectTeam: prop_types_1.default.func,
    selectedTeam: prop_types_1.default.object,
    teams: prop_types_1.default.array
};
exports.Scoreboard.defaultProps = {
    canSelect: false,
    onSelectTeam: function () { },
    selectedTeam: {},
    teams: []
};
